import { render } from "./software-version-cell.vue?vue&type=template&id=8308b1b6&scoped=true&ts=true"
import script from "./software-version-cell.vue?vue&type=script&lang=ts"
export * from "./software-version-cell.vue?vue&type=script&lang=ts"

import "./software-version-cell.vue?vue&type=style&index=0&id=8308b1b6&scoped=true&lang=css"

import exportComponent from "C:\\Users\\claus\\source\\repos\\Joni\\SelfService\\JoniSelfService\\JoniSelfServicePortalUI\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8308b1b6"]])

export default __exports__